import { __assign } from "tslib";
// DS: i3.11
import React from 'react';
import IconWrap from '../IconWrap';
var Ellipsis = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", null,
            React.createElement("path", { d: "M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm14 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" }))))); };
Ellipsis.displayName = 'Ellipsis';
export default Ellipsis;
//# sourceMappingURL=Ellipsis.js.map